import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./pages/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";

import FloatingInstagramBar from "./components/FloatingInstagram"; // ✅ IMPORT CORRECTO

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>

      {/* Barra inferior “a lo largo” */}
      <FloatingInstagramBar
        label="Visita nuestro Instagram"
        bottom={0}
        height={56}
        rounded={0}
        showLabelOnMobile
        zIndex={2000}
      />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

export default App;
